module.exports = __webpack_public_path__ + "static/img/Playtime-Elevated-Building.1870b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/rwc/Playtime-Elevated-Building.png
// module id = 1MQx
// module chunks = 1